import actionTypes from '../../constants/actions/albaran/albaran'

export function initialState () {
  return {
    list: [],
    checkedFiltrosAlbaran: false,
    filtros:{},
    showModalAlbaran: false,
    data: {
      dosisAlbaran: [],
      totalesPorDosis: {total: {tipoDosis: 'total', dosisPedidas: 0, dosisEnviadas: 0, dosisPorServir: 0}},
      checkedFiltrosAlbaranDosis: false,
      showModalAlbaranDosis: false,
      showModalAlbaranRfidValidar: false,
    },
    dataDuplicar: [],
    lecturasDosisAlbaranRFID: []
  }
}

export function fetchAlbaranesSuccess (state, {list, filtros}) {
  return {
    ...state,
    list,
    filtros
  }
}

export function abrirModalVacioAlbaranSuccess (state) {
  return {
    ...state,
    showModalAlbaran: true
  }
}

export function abrirDetallesAlbaranSuccess (state, {data}) {
  return {
    ...state,
    showModalAlbaran: true,
    data: {
      ...state.data,
      ...data,
      totalesPorDosis: state.data.totalesPorDosis,
    }
  }
}

export function cerrarDetallesAlbaranSuccess (state) {
  return {
    ...state,
    showModalAlbaran: false,
    data: {
      ...initialState().data
    }
  }
}

export function seleccionarTodosAlbaranes (state) {
  return {
    ...state,
    checkedFiltrosAlbaran: true
  }
}

export function deseleccionarTodosAlbaranes (state) {
  return {
    ...state,
    checkedFiltrosAlbaran: false
  }
}

export function abrirModalVacioAlbaranDosisSuccess (state) {
  return {
    ...state,
    data: {
      ...state.data,
      showModalAlbaranDosis: true
    }
  }
}

export function abrirDetallesAlbaranDosisSuccess (state) {
  return {
    ...state,
    data: {
      ...state.data,
      showModalAlbaranDosis: true
    }
  }
}

export function cerrarDetallesAlbaranDosisSuccess (state) {
  return {
    ...state,
    data: {
      ...state.data,
      showModalAlbaranDosis: false      
    }
  }
}

export function editarAlbaranDosisSuccess (state, {list}) {  
  return {
    ...state,
    lecturasDosisAlbaranRFID: list,
    data: {
      ...state.data,      
      dosisAlbaran: list,      
    }
  }
}

export function seleccionarTodosModalAlbaranDosis (state) {
  return {
    ...state,
    data: {
      ...state.data,
      checkedFiltrosAlbaranDosis: true
    }
  }
}

export function deseleccionarTodosModalAlbaranDosis (state) {
  return {
    ...state,
    data: {
      ...state.data,
      checkedFiltrosAlbaranDosis: false
    }
  }
}

export function calcTotalesAlbaranDosisSuccess (state, {totalesList}) {
  return {
    ...state,
    data: {
      ...state.data,
      totalesPorDosis: totalesList
    }
  }
}

export function crearAlbaranDesdePedidoSuccess (state, {data}) {
  return {
    ...state,
    data: data
  }
}

export function abrirModalAlbaranRfidValidar (state) {
  return {
    ...state,
    lecturasDosisAlbaranRFID: [],
    data: {
      ...state.data,
      showModalAlbaranRfidValidar: true      
    }
  }
}

export function cerrarModalAlbaranRfidValidar (state) {
  return {
    ...state,
    lecturasDosisAlbaranRFID: [],
    data: {
      ...state.data,
      showModalAlbaranRfidValidar: false
    }
  }
}

export function editarAlbaranDosisRFID (state, {list}) {
    return {
    ...state,
    lecturasDosisAlbaranRFID: list,
  }
}

export function asignaParcialRFID (state, {list}) {  
  return {
    ...state,
    listaParcial: list,
  }
}

export function asignaAcumuladoRFID (state, {value}) {  
  return {
    ...state,
    acumulado: value,
  }
}

export default function (state = initialState(), action) {
  switch (action.type) {
    case actionTypes.FETCH_ALBARANES_SUCCESS:
      return fetchAlbaranesSuccess(state, action)
    case actionTypes.ABRIR_MODAL_VACIO_ALBARAN_SUCCESS:
      return abrirModalVacioAlbaranSuccess(state, action)
    case actionTypes.ABRIR_DETALLES_ALBARAN_SUCCESS:
      return abrirDetallesAlbaranSuccess(state, action)
    case actionTypes.CERRAR_DETALLES_ALBARAN_SUCCESS:
      return cerrarDetallesAlbaranSuccess(state, action)
    case actionTypes.SELECCIONAR_TODOS_ALBARANES:
      return seleccionarTodosAlbaranes(state, action)
    case actionTypes.DESELECCIONAR_TODOS_ALBARANES:
      return deseleccionarTodosAlbaranes(state, action)
    case actionTypes.ABRIR_MODAL_VACIO_ALBARAN_DOSIS_SUCCESS:
      return abrirModalVacioAlbaranDosisSuccess(state, action)
    case actionTypes.ABRIR_DETALLES_ALBARAN_DOSIS_SUCCESS:
      return abrirDetallesAlbaranDosisSuccess(state, action)
    case actionTypes.CERRAR_DETALLES_ALBARAN_DOSIS_SUCCESS:
      return cerrarDetallesAlbaranDosisSuccess(state, action)
    case actionTypes.EDITAR_ALBARAN_DOSIS_SUCCESS:
      return editarAlbaranDosisSuccess(state, action)
    case actionTypes.SELECCIONAR_TODOS_MODAL_ALBARAN_DOSIS:
      return seleccionarTodosModalAlbaranDosis(state, action)
    case actionTypes.DESELECCIONAR_TODOS_MODAL_ALBARAN_DOSIS:
      return deseleccionarTodosModalAlbaranDosis(state, action)
    case actionTypes.CALC_TOTALES_ALBARAN_DOSIS_SUCCESS:
      return calcTotalesAlbaranDosisSuccess(state, action)
    case actionTypes.CREAR_ALBARANES_DESDE_PEDIDO_SUCCESS:
      return crearAlbaranDesdePedidoSuccess(state, action)
    case actionTypes.ABRIR_MODAL_ALBARAN_VALIDACION_RFID:
      return abrirModalAlbaranRfidValidar(state, action)
    case actionTypes.CERRAR_MODAL_ALBARAN_VALIDACION_RFID:
      return cerrarModalAlbaranRfidValidar(state, action)
    case actionTypes.EDITAR_ALBARAN_DOSIS_RFID:
      return editarAlbaranDosisRFID(state, action) 
    case actionTypes.ASIGNA_PARCIAL_RFID:
      return asignaParcialRFID(state, action)
    case actionTypes.ASIGNA_ACUMULADO_RFID:
      return asignaAcumuladoRFID(state, action)
    default:
      return state
  }
}